import type { ViewRuntimeContext } from '../../types/view-component.types';

const EXTERNAL_OR_DOCUMENT_HREF = /^(?:[a-z][a-z0-9+.-]*:|#|\/\/)/i;

export function resolveCustomAppRuntimeHref(
  href: string,
  runtimeContext?: ViewRuntimeContext
): string {
  const value = href.trim();
  const rawBasePath = runtimeContext?.publicBasePath?.trim();
  if (!value || !rawBasePath || EXTERNAL_OR_DOCUMENT_HREF.test(value)) {
    return href;
  }

  const basePath = `/${rawBasePath}`.replace(/\/{2,}/g, '/').replace(/\/$/, '');
  if (!basePath || basePath === '/') return href;
  if (value === basePath || value.startsWith(`${basePath}/`)) return value;
  if (value === '/') return basePath;
  return `${basePath}/${value.replace(/^\/+/, '')}`;
}
